import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility'

//fil out empty contaiers for each table, used for easy check if data exists or not
const initialState = {
    timesheetReport: {timesheetData: [], unitData: [], jobData: []},
    jobReport: {jobData: [], checklistData: [], timesheetData: [], unitData: []},
    defectReport: {defectData: [], unitData: []},
    unitReport: {unitData: []},
    deliveryReport: {deliveryData: [], unitData: []},
    checklistReport: {checklistData: []},
    photoReport: {photoData: []},
    documentReport: {documentData: []},
    trainingReport: {trainingData: []},
    ticketReport: {ticketData: []},
}

//setting table cache removes any old table cache, to ensure doenst bog down site
const updateTableCache = (action) => { 
    let tableKey = action.tableKey
    let tableValue = action.tableValue

    return {
        ...initialState,
        [tableKey]: tableValue
    }
}

const tableCacheReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.UPDATE_TABLECACHE:
            return updateObject(state, updateTableCache(action))
        default:
            return state;
    }
};

export default tableCacheReducer;